var storeFrontApp = angular.module('storefrontApp');
storefrontApp.controller('GiftcardController', ['$scope', '$rootScope', '$window', 'giftcardService', 'ValidationService', 'cartService', '$document', 'URLService',
    function ($scope, $rootScope, $window, giftcardService, validationService, cartService, $document, URLService) {

        // #region Scope Variables
        $scope.regex = validationService.getRegExpPattern();
        $scope.ddlGiftCardAmount = [];
        $scope.amount = 0;
        $scope.addedtocart = false;
        $scope.subimgPath = "/annthegran/images/giftcards/Small/";
        $scope.mainimgPath = "/annthegran/images/giftcards/Medium/";
        $scope.imgPath = "/annthegran/images/giftcards/Large/";
        $scope.lineItemId = getQueryStringValue();

        $scope.ddlGiftCardAmount = [
            "$25 Gift Card",
            "$50 Gift Card",
            "$75 Gift Card",
            "$100 Gift Card",
            "$150 Gift Card",
            "$250 Gift Card"
        ];
        // #endregion

        // #region Date Validation
        var dt = new Date();
        var yyyy = dt.getFullYear().toString();
        var maxYear = (dt.getFullYear() + 1).toString();
        var mm = (dt.getMonth() + 1).toString();
        var dd = (dt.getDate() + 1).toString();
        var maxDay = (dt.getDate()).toString();
        var min = yyyy + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (dd[1] ? dd : "0" + dd[0]); // padding
        var max = maxYear + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (maxDay[1] ? maxDay : "0" + maxDay[0]); // padding
        $scope.minDate = min;
        $scope.maxDate = max;
        //#endregion 

        // #region Initialize Scope Variables
        $scope.recipientname = document.getElementById("hdngiftcardTo").value || "";
        $scope.selectedimage = document.getElementById("hdngiftcardImage").value || "";
        $scope.yourname = document.getElementById("hdngiftcardFrom").value || "";
        $scope.email = document.getElementById("hdngiftcardEmail").value || "";
        $scope.deliverydate = new Date(document.getElementById("hdngiftcardDeliveryDate").value);
        $scope.message = document.getElementById("hdngiftcardMessage").value || "";
        $scope.amount = getGiftCardAmount();
        // #endregion

        // #region GC Functions
        function getQueryStringValue() {
            return URLService.getQueryString('lineItemId', null);
        }
        function getGiftCardAmount() {
            var amount = document.getElementById("hdngiftcardAmount").value || "";
            if (amount != "") {
                var count = 0;
                for (var i = 0; i <= ($scope.ddlGiftCardAmount.length - 1); i++) {
                    if (amount == $scope.ddlGiftCardAmount[i].substring(1, $scope.ddlGiftCardAmount[i].indexOf(' '))) {
                        $scope.selectamount = $scope.ddlGiftCardAmount[i].substring(1, $scope.ddlGiftCardAmount[i].indexOf(' '));
                        count++;
                    }
                }
                if (count == 0) {
                    $scope.customamount = amount;
                }
            }

            return amount;
        }

        function addGiftCardProductToCart(recipientname, sendername, email, deliverydate, amount, message, imagename, lineitemid) {
            cartService
                .addGiftCardProductToCart("gc", recipientname, sendername, email, deliverydate, amount, message, imagename, lineitemid)
                .then(function (response) {
                    if (response && response.data && response.data.itemAdded) {
                        $rootScope.$broadcast("CustomerCartChanged");
                        $scope.addedtocart = true;
                        giftcardform.$submitted = true;
                        giftcardform.$valid = true;
                        if ($scope.lineItemId != null) {
                            $document[0].getElementById("btn_update").classList.add('disabled');
                            $document[0].getElementById("btn_update").classList.remove('loading');
                        } else {
                            $document[0].getElementById("btn_gcaddtocart").classList.add('disabled');
                            $document[0].getElementById("btn_gcaddtocart").classList.remove('loading');
                        }

                        $window.location.href = "/cart";
                    } else {

                        $scope.addedtocart = false;
                        alert("Cart has reached Max Limit. Please checkout before adding any more new item's.");
                    }
                });
        }
        // #endregion

        // #region Scope Functions
        $scope.getGiftCardImages = function () {
            giftcardService.getGiftCardImages()
                .then(function (response) {
                    if (response.data) {
                        if ($scope.selectedimage == null || $scope.selectedimage == "") {
                            $scope.selectedimage = response.data.defaultImage.imgName;
                        }
                        $scope.subimages = response.data.subImages.imgName;
                    }

                });
        }

        $scope.updateAmount = function (flag, giftcardform) {
            if (flag == 1) {
                if (!angular.isUndefined($scope.customamount)) {
                    if (($scope.customamount != null && $scope.customamount != "")) {
                        $scope.customamount = "";
                    }
                }
                $scope.amount = $scope.selectamount;
            }
            else {
                if (($scope.customamount != null && $scope.customamount != "")) {
                    if (!angular.isUndefined($scope.selectamount)) {
                        if ($scope.selectamount != "") {
                            $scope.selectamount = "";
                        }
                    }
                    $scope.amount = $scope.customamount;

                }
            }
            if ($scope.amount != null) {
                giftcardform.noamount = false;
            }
        }

        $scope.validateGiftCard = function (giftcardform) {
            giftcardform.isSubmitted = true;

            if ((angular.isUndefined(giftcardform.selectamount.$modelValue) || (giftcardform.selectamount.$modelValue == ""))
                && (angular.isUndefined($scope.customamount) || ($scope.customamount == ""))) {
                giftcardform.noamount = true;
            }
            else {
                giftcardform.noamount = false;
            }
            if (giftcardform.$valid && giftcardform.noamount == false) {
                var recipientname = giftcardform.recipientname.$modelValue;
                var sendername = giftcardform.yourname.$modelValue;
                var email = giftcardform.email.$modelValue;
                var deliverydate = giftcardform.deliverydate.$viewValue;
                var amount = giftcardform.selectamount.$modelValue || giftcardform.customamount.$modelValue;
                var message = giftcardform.message.$modelValue;
                var imagepath = $scope.imgPath;
                var imagename = $scope.selectedimage;
                var lineitemid = $scope.lineItemId;
                if ($scope.lineItemId != null) {
                    angular.element($document[0].getElementById("btn_update"))[0].disabled = true;
                    $document[0].getElementById("btn_update").classList.add('loading');
                }
                else {
                    angular.element($document[0].getElementById("btn_gcaddtocart"))[0].disabled = true;
                    $document[0].getElementById("btn_gcaddtocart").classList.add('loading');
                }

                if (amount > 0) {

                    addGiftCardProductToCart(recipientname, sendername, email, deliverydate, amount, message, imagename, lineitemid);
                }
                else {


                    $scope.giftcardform.customamount.$invalid = true;
                    if ($scope.lineItemId != null) {
                        angular.element($document[0].getElementById("btn_update"))[0].disabled = false;
                        $document[0].getElementById("btn_update").classList.remove('loading');
                    }
                    else {
                        angular.element($document[0].getElementById("btn_gcaddtocart"))[0].disabled = false;
                        $document[0].getElementById("btn_gcaddtocart").classList.remove('loading');
                    }



                }


            } else {

                $scope.addedtocart = false;
            }


        }

        $scope.switchSelected = function (index) {

            if (!$scope.addedtocart) {
                var elem = $document[0].getElementById("viewselected");
                $scope.selectedimage = $scope.subimages[index];
                elem.src = $scope.imgPath + $scope.selectedimage;
            }

        }
        // #endregion
        
    }]);
